/**
 * SCRIPT INJECTION FOR REPORTING PAGES
 * 
 * Poligon Central location:
 * "System" -> Script Injection
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'reportingScriptInjection',
  initialState: null as null | string,
  reducers: {
    setReportingScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setReportingScriptInjection } = slice.actions;

export default slice.reducer;
